var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8283 2.7464C14.3109 3.0057 10.0747 4.76109 6.69336 7.7746L11.9227 13.004C13.8907 11.3656 16.2802 10.3755 18.8283 10.1427V2.7464Z",
    fill: "#264653"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2649 14.6607L5.03559 9.4314C2.01949 12.8118 0.261914 17.0483 0.000976562 21.5668H7.39762C7.63199 19.0183 8.62418 16.6285 10.2649 14.6607Z",
    fill: "#264653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6026 21.5668H39.9993C39.7383 17.0483 37.9808 12.8118 34.9646 9.4314L29.7354 14.6607C31.3761 16.6284 32.3682 19.0183 32.6026 21.5668Z",
    fill: "#264653"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6012 23.9105C32.4369 25.7154 31.9218 27.2209 31.3126 28.4285C31.9069 29.345 32.4024 30.1195 32.7297 30.6339C33.6211 32.0348 33.4238 33.8331 32.2497 35.0072C31.9646 35.2923 31.639 35.522 31.2861 35.6918L32.504 36.9097C32.7332 37.139 33.0337 37.2536 33.3341 37.2536C33.6346 37.2536 33.935 37.139 34.1641 36.9097C37.6738 33.4004 39.7203 28.8211 40.0004 23.9105H32.6012Z",
    fill: "#264653"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39922 23.9105H0C0.280078 28.8211 2.32656 33.4004 5.83617 36.9098C6.06539 37.139 6.36578 37.2536 6.66617 37.2536C6.96656 37.2536 7.26703 37.139 7.49625 36.9098L11.0519 33.354C11.5102 32.8955 11.5102 32.1522 11.0519 31.6938C10.124 30.7659 7.78672 28.1681 7.39922 23.9105Z",
    fill: "#264653"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3068 7.7746C29.9255 4.76101 25.6892 3.0057 21.1719 2.7464V10.1427C23.7198 10.3755 26.1095 11.3656 28.0774 13.004L33.3068 7.7746Z",
    fill: "#264653"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6036 20.1545C21.1679 18.7188 18.8318 18.7188 17.3961 20.1545C15.9604 21.5902 15.9604 23.9263 17.3961 25.362C19.2099 27.1757 28.1235 32.8671 29.134 33.5101C29.5974 33.805 30.2034 33.7385 30.5918 33.3501C30.9802 32.9617 31.0467 32.3557 30.7518 31.8923C30.1088 30.8819 24.4174 21.9681 22.6036 20.1545Z",
    fill: "#264653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.25e09dcb38c4aaa36444f6cdc326b73f.svg";
export { ForwardRef as ReactComponent };